import React from 'react';
import Input from './Input';
import Textarea from './Textarea';
import Button from './Button';
import './BillingDetails.css';

const BillingDetails = ({ formData, handleChange, handleSubmit }) => {

  // const handleSubmitForm = async (e) => {
  //   e.preventDefault();
  //   handleSubmit(formData); // Call the handleSubmit function passed from props to handle form submission
  // };
  return (
    <form onSubmit={handleSubmit} className="billing-details">
      <h2>Billing Details</h2>
      <div className="input-container">
        <label>GSTIN No :</label>
        <Input type="gstin" name="gstin" value={formData.gstin} onChange={handleChange} maxLength={15} />
      </div>
      <div className="input-container">
        <label>Name :</label>
        <Input name="name" value={formData.name} onChange={handleChange} />
      </div>
      <div className="input-container">
        <label>Email address :</label>
        <Input type="email" name="email" value={formData.email} onChange={handleChange} />
      </div>
      <div className="input-container">
        <label>Mobile No :</label>
        <Input type="tel" name="mobile" value={formData.mobile} onChange={handleChange} />
      </div>
      <div className="input-container">
        <label>HID :</label>
        <Input name="hid" value={formData.hid} onChange={handleChange} maxLength={20} />
      </div>
      <div className="input-container">
        <label>Area Pin Code :</label>
        <Input name="pinCode" value={formData.pinCode} onChange={handleChange} maxLength={6} />
      </div>
      <div className="input-container">
        <label>Address :</label>
        <Textarea name="address" value={formData.address} onChange={handleChange} />
      </div>
      <div className="button-group">
        <Button type="button" text="Back" className="back-button" onClick={() => console.log('Back clicked')} />
        <Button type="submit" text="Proceed to payment" className="proceed-button" />
      </div>
    </form>
  );
};

export default BillingDetails;
